import { TextFontSizes, TextFontWeights } from '.';
import { Typography } from './TextStyle';

export const computeTypography = (
    textFontWeights: TextFontWeights,
    textFontSizes: TextFontSizes,
): Typography => {
    return `Body/${textFontWeights}/Text${textFontSizes}`;
};
